module.exports = "/_next/static/images/69c7cf22aeff19f9334982f80b42183c-card-xs@2x.jpg.webp";